import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { OverviewPriorityGroupDetailComponent } from './overview-priority-group-detail/overview-priority-group-detail.component';
import { ModalService } from '../../modal/modal.service';
import { DetailProjectService } from 'src/app/services/detail-project.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fun-overview-priority-group-timeline',
  templateUrl: './overview-priority-group-timeline.component.html',
  styleUrls: ['./overview-priority-group-timeline.component.scss'],
})
export class OverviewPriorityGroupTimelineComponent implements OnInit, OnChanges {

  @Output() public bookInvestEvent = new EventEmitter<any>();
  @Output() public addressChangedEvent = new EventEmitter<void>();
  @Input() public detailProject;
  @Input() public myInvestment;
  @Input() public profileType: number;
  @Input() public projectDeal: any;

  get isProfileRestricted(): boolean {
    return (this.detailProject?.canLegalInvest === false && this.profileType === 2) ||
           (this.detailProject?.canNaturalInvest === false && this.profileType === 1);
  }

  get isLocalInvestorsOnly(): boolean {
    const stages = this.detailProject?.postal_code_investment_stages || [];
    const hasPriorityGroups = stages.some((s: any) => s.priority_groups?.length > 0);
    const hasGlobalPhase = stages.some((s: any) => s.type === 3);
    const userHasGroup = this.detailProject?.highestUserGroup !== undefined;
    return hasPriorityGroups && !hasGlobalPhase && !userHasGroup;
  }

  public stageActive = null;
  stageWithPriorityGroups: any;
  showConsolidationDateAdvise = false;
  mainCtaType = 'colorFull';
  mainCtaTitle = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.INVEST');

  constructor(
    private modalService: ModalService,
    private detailProjectService: DetailProjectService,
    public chdRef: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const stages = this.detailProject?.postal_code_investment_stages;
    this.stageActive = stages?.find(
      (_, index) =>
        this.detailProjectService.getIfIsStageActive(index, this.detailProject)
    ) ?? null;
    this.stageWithPriorityGroups = stages?.find(
      (stage) =>
        stage.priority_groups
    ) ?? null;
    this.setMainCtaActionAndTitle();
    this.chdRef.detectChanges();
  }

  ngOnChanges(): void {
    this.setMainCtaActionAndTitle();
  }

  setMainCtaActionAndTitle() {
    const pendingSignInvestments = this.myInvestment.filter((item) => item['status'] === -2);
    //if (this.myInvestment && this.myInvestment.length > 0) {

    if (this.detailProject['is_consolidation_date']) {
      if (pendingSignInvestments.length > 0) {
        this.mainCtaTitle = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.FORMALIZE');
        this.mainCtaType = 'colorFull';
        this.showConsolidationDateAdvise = false;
      } else {
        this.mainCtaTitle = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.INVEST');
        this.mainCtaType = 'colorFull-disabled';
        this.showConsolidationDateAdvise = true;
      }
    } else {
      if ((this.stageActive.type === 1 || !this.detailProject['highestUserGroup'])) {
        if (pendingSignInvestments.length > 0) {
          this.mainCtaTitle = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.FORMALIZE');
          this.mainCtaType = 'colorFull';
          this.showConsolidationDateAdvise = false;
        } else {
          this.mainCtaTitle = this.stageActive.type === 3 ? this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.INVEST') : this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.RESERVE');
          this.mainCtaType = 'colorFull';
          this.showConsolidationDateAdvise = false;
        }
      } else if ((this.stageActive.type === 2 && this.detailProject['highestUserGroup']) || this.stageActive.type === 3) {
        if (pendingSignInvestments.length > 0) {
          this.mainCtaTitle = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.FORMALIZE');
          this.mainCtaType = 'colorFull';
          this.showConsolidationDateAdvise = false;
        } else {
          this.mainCtaTitle = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.INVEST');
          this.mainCtaType = 'colorFull';
          this.showConsolidationDateAdvise = false;
        }
      }
    }

    //}
  }

  public isStageActive(index: number): boolean {
    return this.detailProjectService.getIfIsStageActive(index, this.detailProject);
  }

  public isStagePassed(index: number): boolean {
    return this.detailProjectService.isStagePassed(index, this.detailProject);
  }

  public hasUserPriorityGroup(stage: any): boolean {
    return this.detailProjectService.hasUserPriorityGroup(stage);
  }

  public allUserGroupsFull(stage: any): boolean {
    if (!stage?.priority_groups?.length) return false;
    const userGroups = stage.priority_groups.filter((pg: any) => pg.isEnabledForUser);
    return userGroups.length > 0 && userGroups.every((pg: any) => pg.isGroupObjetiveFull);
  }

  viewDetails(stage) {
    const params = { stage, detailProject: this.detailProject, projectDeal: this.projectDeal };
    this.modalService.showModal(OverviewPriorityGroupDetailComponent, params, '', '', true).subscribe((modal: any) => {
      modal.onClose().subscribe();
      modal.getChildComponent().subscribe((componentRef: OverviewPriorityGroupDetailComponent) => {
        componentRef.removeComponentEvent.subscribe(() => {
          modal.close();
        });
        componentRef.addressChangedEvent.subscribe(() => {
          this.addressChangedEvent.emit();
        });
      });
    });
  }

  bookInvestment() {
    this.bookInvestEvent.emit();
  }

}
